import React from "react";
import { metrics } from "@riot-private/pubhub-sdk";
import type { MarkupbotPage } from "./types";
import { serializeJsonLd } from "./serialize";

export type MarkupbotProps = {
  page: MarkupbotPage;
};

export function Markupbot({ page }: MarkupbotProps) {
  if (!page.jsonLd) return null;
  try {
    const serialized = serializeJsonLd(page.jsonLd);
    return (
      <script
        type="application/ld+json"
        data-markupbot={page.type ?? "unknown"}
        dangerouslySetInnerHTML={{ __html: serialized }}
      />
    );
  } catch (error) {
    // console.error is intentional on SSR — captured by the Datadog log pipeline.
    // metrics.noticeError is browser-only (New Relic agent is client-side).
    console.error("Markupbot failed to serialize JSON-LD:", error);
    if (typeof window !== "undefined" && error instanceof Error) {
      metrics.noticeError(error);
    }
    return null;
  }
}
